import { Link as RouterLink } from "react-router-dom";
import React from "react";

export default function Link(props){
  const style = {
      textDecoration: "none",
      color: "inherit",
  };
  return <RouterLink style={style} {...props} />;
}